<template>
  <div class="row align-items-center cardPadrao shadow mx-0" @click="abrirModal">
    <b-icon class="col-2 col-md-3" :icon="icon" font-scale="4"></b-icon>
    <div class="col-10 col-md-9">
      <div class="card-title text-left">
        <h4 class="card-title card-titulo">{{ titulo }}</h4>
      </div>
      <div class="card-subtitle text-left text-muted">
        <h6 class="card-subtitulo">{{ descricao }}</h6>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
      required: true,
    },
    descricao: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
  methods: {
    abrirModal() {
      this.$emit('abrirModal')
    }
  }
};
</script>


<style >
.cardPadrao {
  padding: 1rem 0;
  border-radius: 1rem;
  background-color: #f5f5f5;
  border-color: #f5f5f5;
  border-top: 0.4rem solid  var(--cor-base);
  min-height: 8rem;
  height: 100%;
  width: 100%;
  transition: 0.3s;
}

.cardPadrao:hover {
  transform: scale(1.03);
  transition: 0.3s;
}

.card-titulo {
  color: #000000;
  font-size: 1.1rem;
  font-weight: 600;
}

.card-subtitulo {
  font-size: 1rem;
}

h6 {
  font-size: 1rem;
  font-weight: 400;
  color: #6c757d;
}
</style>